import React from 'react';
import { Button, mergeClasses } from '@fluentui/react-components';
import { Open20Regular } from '@fluentui/react-icons';
import { useExternalLinkStyles } from '../../styles';

export const ItemExternalLink = (props) => {
  const { onClick, text } = props;
  const classes = useExternalLinkStyles();

  return (
    <Button className={mergeClasses('external-button', classes.externalButton)} onClick={onClick}>
      <Open20Regular />
      <span className={classes.text}>{text}</span>
    </Button>
  );
};
